import { combineReducers } from 'redux';

import { Action } from '../actions';
import { State } from '../models';
import { editorReducer } from './editor';
import { noticesReducer } from './notices';
import { searchReducer } from './search';

export const rootReducer = combineReducers<State, Action>({
  notices: noticesReducer,
  editor: editorReducer,
  search: searchReducer,
});
